/**
 * Collection / search results history.
 *
 * Stacks page, q, sort, take, and filter params with pushState (no reload)
 * so Back/Forward restore the same results. URL writes happen only from
 * user page/filter actions. Popstate restores USF from the popped URL and
 * never rewrites the address bar from in-memory state. Hash/anchor updates
 * do not create extra history entries on results pages.
 */
(function () {
  'use strict';

  var RESULT_PARAM = /^(?:page|q|usf_sort|usf_take|usf_ipp|usf_view|sort_by|uff_.*|filter\..*)$/;
  var RESULT_KEYS_TO_REPLACE = ['page', 'q', 'usf_sort', 'usf_take', 'usf_ipp', 'usf_view', 'sort_by', /uff_.*/, /filter\..*/];
  var FILTER_CLICK = '.usf-sr-filters, .usf-facets, .usf-facet, .usf-sr-config, .usf-sort, [class*="usf-sort"], [class*="usf-filter"]';
  var applying = false;
  var fromHistory = false;
  var fromHistoryTimer = 0;
  var allowHashWrite = false;
  var userIntent = null;
  var origPush;
  var origReplace;

  function isResultsPage() {
    if (document.getElementById('usf_container')) return true;
    if (document.querySelector('results-list')) return true;
    var template = document.querySelector('main[data-template]');
    var name = template && template.getAttribute('data-template');
    return name === 'collection' || name === 'search' || (name && name.indexOf('search') === 0);
  }

  function resolveUrl(href) {
    return new URL(href, location.href);
  }

  function resultKey(href) {
    try {
      var url = resolveUrl(href);
      var parts = [];
      url.searchParams.forEach(function (value, key) {
        if (RESULT_PARAM.test(key)) parts.push(key + '=' + value);
      });
      parts.sort();
      return url.pathname + '?' + parts.join('&');
    } catch (err) {
      return String(href);
    }
  }

  function stripHash(urlArg) {
    if (urlArg == null || urlArg === '') return urlArg;
    try {
      var url = resolveUrl(urlArg);
      return url.pathname + url.search;
    } catch (err) {
      return urlArg;
    }
  }

  function markFromHistory() {
    fromHistory = true;
    userIntent = null;
    window.__tcResultsFromHistory = true;
    if (fromHistoryTimer) clearTimeout(fromHistoryTimer);
    fromHistoryTimer = setTimeout(function () {
      fromHistory = false;
      window.__tcResultsFromHistory = false;
      fromHistoryTimer = 0;
    }, 4000);
  }

  function clearFromHistory() {
    fromHistory = false;
    window.__tcResultsFromHistory = false;
    if (fromHistoryTimer) {
      clearTimeout(fromHistoryTimer);
      fromHistoryTimer = 0;
    }
  }

  function currentPageFromDom() {
    var active = document.querySelector('.usf-sr-pages__page.usf-active');
    if (active) {
      var fromActive = parseInt(active.textContent, 10);
      if (fromActive) return fromActive;
    }
    if (window.usf && usf.search && typeof usf.search.page === 'number') {
      return usf.search.page;
    }
    if (window.usf && usf.queryRewriter && usf.queryRewriter.page) {
      return parseInt(usf.queryRewriter.page, 10) || 1;
    }
    var card = document.querySelector('.product-grid__item[data-page], [data-usf-pid][data-page]');
    return card ? parseInt(card.getAttribute('data-page'), 10) || 1 : 1;
  }

  function pageFromUsfMemory() {
    if (window.usf && usf.queryRewriter && usf.queryRewriter.page) {
      return parseInt(usf.queryRewriter.page, 10) || 1;
    }
    if (window.usf && usf.search && typeof usf.search.page === 'number') {
      return usf.search.page;
    }
    return currentPageFromDom();
  }

  function pageFromLocation() {
    return parseInt(new URLSearchParams(location.search).get('page'), 10) || 1;
  }

  function collectResultParams(search) {
    var desired = {};
    new URLSearchParams(search).forEach(function (value, key) {
      if (!RESULT_PARAM.test(key)) return;
      if (Object.prototype.hasOwnProperty.call(desired, key)) {
        desired[key] = [].concat(desired[key], value);
      } else {
        desired[key] = value;
      }
    });
    return desired;
  }

  function applyResultParamsToUrl(url, params, page) {
    var resultKeys = [];
    url.searchParams.forEach(function (_value, key) {
      if (RESULT_PARAM.test(key)) resultKeys.push(key);
    });
    resultKeys.forEach(function (key) {
      url.searchParams.delete(key);
    });

    Object.keys(params).forEach(function (key) {
      var value = params[key];
      if (key === 'page' && String(value) === '1') return;
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          if (item != null && item !== '') url.searchParams.append(key, item);
        });
      } else if (value != null && value !== '') {
        url.searchParams.append(key, value);
      }
    });

    if (page > 1) url.searchParams.set('page', String(page));
    else url.searchParams.delete('page');
    return url;
  }

  function resultParamsFromUsf() {
    if (window.usf && usf.query && typeof usf.query.entries === 'function') {
      var params = {};
      usf.query.entries().forEach(function (pair) {
        var key = pair[0];
        var value = pair[1];
        if (!RESULT_PARAM.test(key)) return;
        params[key] = value;
      });
      return params;
    }
    return collectResultParams(location.search);
  }

  function buildResultsUrl(pageOverride) {
    var url = resolveUrl(location.href);
    url.hash = '';
    var page = pageOverride != null ? parseInt(pageOverride, 10) || 1 : pageFromUsfMemory();
    return applyResultParamsToUrl(url, resultParamsFromUsf(), page);
  }

  function writeResultsUrl(nextUrl, replace, forceUser) {
    if (fromHistory && !forceUser) return false;
    if (!nextUrl || resultKey(nextUrl) === resultKey(location.href)) return false;

    applying = true;
    try {
      var pathAndSearch = nextUrl.pathname + nextUrl.search;
      var state = { tileclubResults: true, page: parseInt(nextUrl.searchParams.get('page'), 10) || 1 };
      if (replace) {
        history.replaceState(history.state && history.state.tileclubResults ? Object.assign({}, history.state, state) : state, '', pathAndSearch);
      } else {
        history.pushState(state, '', pathAndSearch);
      }
    } catch (err) {
      applying = false;
      return false;
    }
    applying = false;
    return true;
  }

  function syncUrlFromUsf(options) {
    var forceUser = options && options.forceUser;
    if (!isResultsPage() || applying) return;
    if (fromHistory && !forceUser) return;
    if (!forceUser && !userIntent) return;

    if (forceUser) clearFromHistory();

    var page = options && options.page ? parseInt(options.page, 10) : pageFromUsfMemory();
    if (options && options.page && (!page || page < 1)) page = currentPageFromDom();
    var url = buildResultsUrl(page);
    var wrote = writeResultsUrl(url, options && options.replace, forceUser);
    if (wrote || resultKey(url) === resultKey(location.href)) {
      userIntent = null;
    }
  }

  function installHistoryWrap() {
    if (history.__tcResultsHistoryWrapped) return;
    history.__tcResultsHistoryWrapped = true;

    origPush = history.pushState.bind(history);
    origReplace = history.replaceState.bind(history);

    history.pushState = function (state, title, url) {
      if (url && !allowHashWrite && isResultsPage()) url = stripHash(url);
      return origPush(state, title, url);
    };

    history.replaceState = function (state, title, url) {
      var next = url;
      if (next && !allowHashWrite && isResultsPage()) next = stripHash(next);
      if (
        next &&
        !applying &&
        !fromHistory &&
        isResultsPage() &&
        resultKey(next) !== resultKey(location.href)
      ) {
        return origPush(state, title, next);
      }
      return origReplace(state, title, next != null ? next : url);
    };
  }

  function persistResultsUrl(link) {
    if (!isResultsPage()) return;

    var url = resolveUrl(location.href);
    var page = pageFromUsfMemory();
    if (page > 1) url.searchParams.set('page', String(page));
    else url.searchParams.delete('page');

    if (link && link.id) {
      url.hash = link.id;
    } else {
      url.hash = '';
    }

    applying = true;
    allowHashWrite = true;
    try {
      history.replaceState(history.state || { tileclubResults: true, page: page }, '', url.pathname + url.search + url.hash);
    } catch (err) {
      /* ignore */
    }
    allowHashWrite = false;
    applying = false;
  }

  function applyLocationToUsf(force) {
    if (!isResultsPage() || !window.usf || !usf.query) return;

    var urlPage = pageFromLocation();
    var memoryPage = pageFromUsfMemory();
    var sameKey = resultKey(location.href) === resultKey(buildResultsUrl());
    if (sameKey && urlPage === memoryPage) return;

    markFromHistory();
    applying = true;
    try {
      var desired = collectResultParams(location.search);
      if (typeof usf.query.update === 'function') {
        usf.query.update(desired, RESULT_KEYS_TO_REPLACE, { replace: true, force: true });
      }

      var rewriter = usf.queryRewriter;
      var searchVm = usf.search;
      if (rewriter && (parseInt(rewriter.page, 10) || 1) !== urlPage) {
        rewriter.page = urlPage;
      }
      if (searchVm && searchVm.page !== urlPage) searchVm.page = urlPage;
      if (searchVm && typeof searchVm.refresh === 'function') {
        searchVm.refresh();
      } else if (searchVm && typeof usf.fetch === 'function') {
        usf.fetch(searchVm);
      }
    } catch (err) {
      /* ignore */
    }
    applying = false;
  }

  function protectPageFromUnchangedTerm() {
    var rewriter = usf.queryRewriter;
    if (!rewriter || rewriter.__tcTermPatched) return;

    var proto = Object.getPrototypeOf(rewriter);
    var descriptor = Object.getOwnPropertyDescriptor(proto, 'term') || Object.getOwnPropertyDescriptor(rewriter, 'term');
    if (!descriptor || typeof descriptor.set !== 'function' || typeof descriptor.get !== 'function') return;

    rewriter.__tcTermPatched = true;
    var originalSet = descriptor.set;
    var originalGet = descriptor.get;

    Object.defineProperty(rewriter, 'term', {
      configurable: true,
      get: function () {
        return originalGet.call(this);
      },
      set: function (value) {
        var previous = originalGet.call(this);
        var page = this.page;
        originalSet.call(this, value);
        var sameTerm = String(value == null ? '' : value) === String(previous == null ? '' : previous);
        if (sameTerm && page > 1 && this.page === 1) {
          applying = true;
          try {
            this.page = page;
          } catch (err) {
            /* ignore */
          }
          applying = false;
        }
      },
    });
  }

  function bindPaginationHrefs(root) {
    if (!window.usf || !usf.queryRewriter || typeof usf.queryRewriter.getPageUrl !== 'function') return;

    (root || document).querySelectorAll('.usf-sr-pages a').forEach(function (anchor) {
      var item = anchor.closest('li');
      if (!item) return;

      var href;
      if (item.classList.contains('usf-sr-pages__prev')) {
        href = usf.queryRewriter.getPageUrl(currentPageFromDom() - 1);
      } else if (item.classList.contains('usf-sr-pages__next')) {
        href = usf.queryRewriter.getPageUrl(currentPageFromDom() + 1);
      } else {
        var textPage = parseInt(anchor.textContent, 10);
        if (textPage) href = usf.queryRewriter.getPageUrl(textPage);
      }

      if (href && href.indexOf('javascript:') !== 0) {
        try {
          href = stripHash(href);
        } catch (err) {
          /* keep original */
        }
        anchor.setAttribute('href', href);
      }
    });
  }

  function disableThemeInfiniteScrollOnUsf() {
    document.querySelectorAll('results-list').forEach(function (list) {
      if (!list.querySelector('#usf_container')) return;
      list.setAttribute('data-usf-manages-results', '');
      if (list.infinityScrollObserver) {
        list.infinityScrollObserver.disconnect();
        list.infinityScrollObserver = null;
      }
    });
  }

  function pageFromPaginationLink(link) {
    try {
      var dest = resolveUrl(link.href);
      if (dest.protocol !== 'javascript:' && dest.origin === location.origin) {
        if (dest.searchParams.has('page')) {
          var fromHref = parseInt(dest.searchParams.get('page'), 10);
          if (fromHref >= 1) return fromHref;
        } else {
          var arrow = link.closest('li');
          if (arrow && (arrow.classList.contains('usf-sr-pages__prev') || arrow.classList.contains('usf-sr-pages__next'))) {
            return 1;
          }
        }
      }
    } catch (err) {
      /* fall through */
    }

    var item = link.closest('li');
    if (item && item.classList.contains('usf-sr-pages__prev')) return currentPageFromDom() - 1;
    if (item && item.classList.contains('usf-sr-pages__next')) return currentPageFromDom() + 1;

    var textPage = parseInt(link.textContent, 10);
    if (textPage) return textPage;

    return 0;
  }

  function isInPageHashLink(link) {
    var raw = link.getAttribute('href');
    if (!raw || raw.charAt(0) !== '#') return false;
    if (raw === '#' || raw === '#MainContent') return true;
    try {
      var dest = resolveUrl(link.href);
      return dest.pathname === location.pathname && dest.search === location.search;
    } catch (err) {
      return true;
    }
  }

  function onDocumentClick(event) {
    if (!isResultsPage()) return;
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('a');
    if (link && isInPageHashLink(link)) {
      event.preventDefault();
      var id = (link.getAttribute('href') || '').slice(1);
      var el = id && document.getElementById(id);
      if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView();
      return;
    }

    if (link && link.closest('.usf-sr-pages')) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;
      var page = pageFromPaginationLink(link);
      if (page >= 1) {
        event.preventDefault();
        userIntent = { page: page };
        syncUrlFromUsf({ page: page, forceUser: true });
      }
      return;
    }

    if (target.closest(FILTER_CLICK) && !target.closest('a[href*="/products/"]')) {
      userIntent = { filters: true };
      return;
    }

    if (!link) return;
    if (event.defaultPrevented) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return;
    if (link.closest('button, input, label, select, add-to-cart-component, quick-add-component')) return;

    var dest;
    try {
      dest = resolveUrl(link.href);
    } catch (err) {
      return;
    }
    if (dest.origin !== location.origin) return;
    if (dest.pathname.indexOf('/products/') === -1) return;
    if (dest.pathname === location.pathname) return;

    persistResultsUrl(link);
  }

  function onDocumentChange(event) {
    if (!isResultsPage() || !event.target || !event.target.closest) return;
    if (event.target.closest('#usf_container, .usf-sr-filters, .usf-sr-config')) {
      userIntent = { filters: true };
    }
  }

  function onHashChange(event) {
    if (!isResultsPage() || applying || fromHistory || allowHashWrite) return;
    try {
      var oldUrl = new URL(event.oldURL);
      var newUrl = new URL(event.newURL);
      if (oldUrl.pathname !== newUrl.pathname || oldUrl.search !== newUrl.search) return;
      applying = true;
      history.replaceState(history.state, '', newUrl.pathname + newUrl.search);
      applying = false;
    } catch (err) {
      applying = false;
    }
  }

  function whenUsfReady(callback) {
    if (window.usf && usf.event && typeof usf.event.add === 'function' && usf.queryRewriter) {
      callback();
      return;
    }
    setTimeout(function () {
      whenUsfReady(callback);
    }, 25);
  }

  function onReady() {
    if (!isResultsPage()) return;

    try {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (err) {
      /* ignore */
    }

    disableThemeInfiniteScrollOnUsf();
    bindPaginationHrefs();

    window.addEventListener(
      'popstate',
      function () {
        markFromHistory();
        applyLocationToUsf(true);
        bindPaginationHrefs();
      },
      true
    );

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      markFromHistory();
      setTimeout(function () {
        applyLocationToUsf(true);
        bindPaginationHrefs();
      }, 0);
    });

    window.addEventListener('hashchange', onHashChange);

    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('change', onDocumentChange, true);
  }

  installHistoryWrap();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  whenUsfReady(function () {
    protectPageFromUnchangedTerm();
    if (typeof usf.event.add === 'function') {
      usf.event.add('init', function () {
        protectPageFromUnchangedTerm();
        if (pageFromLocation() !== pageFromUsfMemory()) applyLocationToUsf(true);
        bindPaginationHrefs();
        disableThemeInfiniteScrollOnUsf();
      });
      usf.event.add('sr_updated', function () {
        bindPaginationHrefs();
        disableThemeInfiniteScrollOnUsf();
        if (fromHistory) {
          setTimeout(clearFromHistory, 250);
          return;
        }
        if (userIntent) syncUrlFromUsf({ forceUser: true });
      });
    }
    if (isResultsPage() && pageFromLocation() !== pageFromUsfMemory()) {
      applyLocationToUsf(true);
      bindPaginationHrefs();
    }
  });
})();
